var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMounted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24381 16.9194L1.85942 19.3354C0.713527 19.8562 0.713527 20.7091 1.85942 21.2299L11.4953 25.6245C12.595 26.1252 14.405 26.1252 15.5047 25.6245L25.1406 21.2299C26.2865 20.7091 26.2865 19.8562 25.1406 19.3354L19.9359 16.8308M25.1354 5.79495L15.4109 1.36133C14.3568 0.879557 12.6315 0.879557 11.5774 1.36133L1.85942 5.79495C0.713527 6.31579 0.713527 7.16801 1.85942 7.68885L11.4953 12.0834C12.595 12.5847 14.405 12.5847 15.5047 12.0834L25.1406 7.68885C26.2813 7.16801 26.2813 6.31514 25.1354 5.79495Z",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2489 10.0909L1.85922 12.5121C0.713592 13.0334 0.713592 13.8869 1.85922 14.4082L11.4929 18.8055C12.5924 19.3072 14.4019 19.3072 15.5014 18.8055L25.1351 14.4082C26.2872 13.8869 26.2872 13.0334 25.1416 12.5121L19.7467 10.0909",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMounted);
export default __webpack_public_path__ + "static/media/mounted.aa9b26cbc030c99a7c733e45381e065a.svg";
export { ForwardRef as ReactComponent };